<template>
  <vuestic-widget class="chart-widget" :headerText="chartTitle">
    <vuestic-chart
      v-if="chartData"
      v-bind:data="chartData"
      type="line"
    ></vuestic-chart>
  </vuestic-widget>
</template>

<script>
import utils from 'services/utils'

export default {
  name: 'LineChart',
  props: ['chartTitle', 'stats'],
  computed: {
    chartData() {
      let chart = {}
      let palette = this.$store.getters.palette
      if (this.stats) {
        if (this.stats.labels) {
          chart = {
            labels: this.stats.labels,
            datasets: [
              {
                label: [this.chartTitle],
                backgroundColor: utils.hex2rgb(palette.primary, 0.6).css,
                borderColor: palette.transparent,
                data: this.stats.values
              }
            ]
          }
        } else {
          chart = {
            labels: this.stats.incoming.labels,
            datasets: [
              {
                label: 'incoming',
                backgroundColor: utils.hex2rgb(palette.primary, 0.6).css,
                borderColor: palette.transparent,
                data: this.stats.incoming.values
              },
              {
                label: 'outgoing',
                backgroundColor: utils.hex2rgb(palette.info, 0.6).css,
                borderColor: palette.transparent,
                data: this.stats.outgoing.values
              }
            ]
          }
        }
      }

      return chart
    }
  }
}
</script>
